export default __webpack_public_path__ + "static/media/icon_2.a8ec25ab.svg";